export default "/images/fced9b66233115b102f16a86d412504b.avif";